const isDevelopment = process.env.NODE_ENV === "development";

export const API_BASE_URL = isDevelopment
  ? // ? "http://213.142.132.38/api/v0/"
    // "http://api.johny.click/api/v0/"
    "http://localhost/api/v0/"
  : "https://api.cogitofund.com/api/v0/";

export const WS_BASE_URL = isDevelopment
  ? // ? "ws://213.142.132.38/ws/"
    "http://localhost/ws/"
  : // "ws://api.johny.click/ws/"
    "wss://api.cogitofund.com/ws/";

export const buildWsUrl = (path, queryParams = {}) => {
  const normalizedPath = String(path || "")
    .replace(/^\/+/, "")
    .replace(/^ws\//, "");
  const url = new URL(normalizedPath, WS_BASE_URL);

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
};
